export const COLLABORATION_INDEX_PATH = "/collaboration";

export function shouldFetchCollaborationData({ logisticCompanyPrepareChange }) {
  return !logisticCompanyPrepareChange;
}

export function didCollaborationTenantContextChange(prevProps, nextProps) {
  return (
    prevProps.logisticCompanyId !== nextProps.logisticCompanyId ||
    (prevProps.logisticCompanyPrepareChange &&
      !nextProps.logisticCompanyPrepareChange)
  );
}
